










import { Component, Vue } from "vue-property-decorator";
import SelectCategoryModal from "@/components/SelectCategoryModal/SelectCategoryModal.vue";
import PopupMessage from "@/components/PopupMessage/PopupMessage.vue";
import PopupImageView from "@/components/PopupImageView/PopupImageView.vue";
import PopupResend from "@/components/PopupResend/PopupResend.vue";

@Component<App>({
  components: {
    SelectCategoryModal,
    PopupMessage,
    PopupImageView,
    PopupResend,
  },
})
export default class App extends Vue {
  
}
